// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "b06a2a89","122": "21a578a4","354": "9c6094ad","489": "f69de08d","535": "19cfe421","587": "5d05e135","783": "e77dd7af","90": "fe81ad12",}[chunkId] + ".js"
}